<template>
  <div class="upload-file">
    <v-alert :value="showAlert" type="error" dismissible v-if="errors.has('photoUpload')">
      {{ errors.first('photoUpload') }}
    </v-alert>
    <template v-if="!showOnlyButton">
      <template v-if="currentImage">
        <div
          class="text-xs-center preview-img"
          style="
          overflow: hidden;
          min-height: 150px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        "
          :style="{
            'min-height': height + 'px',
            'background-image': 'url(\'' + currentImage + '\')'
          }"
        >
          <template v-if="loading">
            <div
              style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
            >
              <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
            </div>
          </template>
          <div v-else class="overlay">
            <v-layout
              justify-center
              fill-height
              align-center
              row
              class="mb-0"
              style="min-height: 100%"
              :style="{ 'min-height': height + 'px' }"
            >
              <div @click="onClickUploadButton">
                <slot>
                  <v-btn small depressed color="primary" style="font-size: 11px">
                    <span class="fa fa-camera mr-1"></span>
                    {{ $t('select file to upload') }}
                  </v-btn>

                  <div class="caption text-xs-center" style="color: white">
                    {{ $t('upload file size: {size}MB', { size: 10 }) }}
                  </div>
                </slot>
              </div>
            </v-layout>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="text-xs-center">
          <div
            style="min-height: 150px; background: #eee; overflow: hidden; position: relative"
            :style="{ 'min-height': height + 'px' }"
          >
            <template v-if="loading">
              <div
                style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
              >
                <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
              </div>
            </template>
            <template v-else>
              <v-layout
                justify-center
                fill-height
                align-center
                row
                class="mb-0"
                style="min-height: 100%"
                :style="{ 'min-height': height + 'px' }"
              >
                <div @click="onClickUploadButton">
                  <slot>
                    <v-btn small depressed color="primary" style="font-size: 11px">
                      <span class="fas fa-file-alt mr-2"></span>
                      {{ $t('select file to upload') }}
                    </v-btn>

                    <div class="caption grey--text text-xs-center">
                      {{ $t('upload file size: {size}MB', { size: 10 }) }}
                    </div>
                  </slot>
                </div>
              </v-layout>
            </template>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div @click="onClickUploadButton">
        <slot v-bind="{ loading }">
          <v-btn
            small
            depressed
            class="mx-0"
            color="primary"
            style="font-size: 11px"
            :loading="loading"
          >
            <span class="fa fa-camera mr-1"></span>
            {{ $t('select file to upload') }}
          </v-btn>

          <div class="caption mb-2">
            {{ $t('upload file size: {size}MB', { size: 10 }) }}
          </div>
        </slot>
      </div>
      <v-btn class="mx-0 customExamfileBtn" flat :href="value" v-if="value">{{
        value | truncate(20)
      }}</v-btn>
      <v-btn class="mx-0 clearBtn" icon v-if="value" @click="clearData"
        ><v-icon>close</v-icon></v-btn
      >
    </template>

    <input
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      :id="'photoUploadInput' + objId"
      data-vv-as="File"
      :multiple="multiple"
      @change="onFileChange($event)"
      accept=".xlsx,.mp4,.txt,.zip,.text,.pdf,text/plain,.csv,.rar,.doc,.docx"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
      v-validate="'required|mimes:.xlsx,.mp4,.txt,.text,.pdf,text/plain,.zip,.csv,.rar,.doc,.docx'"
    />
  </div>
</template>
<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import moment from 'moment'

export default {
  props: {
    value: null,
    height: {
      default: 250,
      type: Number
    },
    outputtype: {
      default: 'url',
      type: String
    },
    multiple: {
      default: false
    },
    showOnlyButton: {
      default: false
    }
  },
  data: function() {
    return {
      filelength: 0,
      multiplefile: [],
      base64img: '',
      currentImage: this.value,
      loading: false,
      objId: null,
      uploadtimestamp: moment().format('x'),
      showAlert: false
    }
  },
  components: {
    SyncLoader
  },
  created: function() {
    // if (!this.height || this.height === 'undefined') {
    // 	this.height = 250
    // }
    this.objId = Math.random()
  },
  methods: {
    clearData() {
      this.value = null
    },
    onClickUploadButton: function() {
      document.getElementById('photoUploadInput' + this.objId).click()
    },
    fileResize: function(file) {
      let vm = this
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onloadend = function() {
          var tempImg = new Image()
          tempImg.src = reader.result
          tempImg.onload = function() {
            var MAX_WIDTH = 2000
            var MAX_HEIGHT = 2000
            if (vm.outputtype == 'base64') {
              MAX_WIDTH = 500
              MAX_HEIGHT = 500
            }
            var tempW = tempImg.width
            var tempH = tempImg.height
            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW
                tempW = MAX_WIDTH
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH
                tempH = MAX_HEIGHT
              }
            }

            var canvas = document.createElement('canvas')
            canvas.width = tempW
            canvas.height = tempH
            var ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, tempW, tempH)
            var dataURL = canvas.toDataURL('image/jpeg')
            var data = 'image=' + dataURL
            try {
              if (vm.outputtype == 'base64') {
                vm.$emit('input', dataURL)
                vm.currentImage = dataURL
                vm.$emit('onUploaded', dataURL)
              }
              var obj = vm.dataURItoBlob(data)
              obj.name = file.name
              resolve(obj)
            } catch (error) {
              vm.$swal({
                title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                type: 'error',
                text: `dataURItoBlob: ${error}`,
                confirmButtonText: vm.$t('Confirm')
              })
              reject()
            }
          }
        }
        reader.readAsDataURL(file)
      })
    },
    dataURItoBlob: function(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: async function(event) {
      var vm = this

      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.showAlert = true
        this.uploadtimestamp = moment().format('x')
        return
      } else {
        this.showAlert = false
        this.loading = true
        let files = event.target.files || event.dataTransfer.files
        if (!files.length) {
          this.uploadtimestamp = moment().format('x')
          return
        } else {
          vm.filelength = files.length
        }
        if (vm.multiple) {
          for (let file of files) {
            // var obj = await vm.fileResize(file)
            await vm.createImage(file)
          }
        } else {
          // console.log('loading is ' + this.loading)
          vm.createImage(files[0])
          event.target.value = ''
        }

        this.loading = false
      }
    },
    async createImage(file) {
      try {
        await this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function(error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          vm.loading = false
          vm.$emit('input', vm.currentImage)
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve()
        })
      })
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.currentImage = newVal
    }
  }
}
</script>
<style lang="scss" scoped>
.clearBtn {
  background-color: #e6f0fb !important;
  font-weight: 600;
  font-size: 12px;
  border-radius: 0 6px 6px 0 !important;
  position: absolute;
  left: 170px;
  .v-btn__content{
    i{
      font-size: 14px !important;
      color: #0C2F53;
    }
  }
}
.clearBtn:hover{
  position: absolute;
}
.clearBtn:before {
  border-radius: 0 6px 6px 0 !important;
}
.customExamfileBtn {
  background-color: #e6f0fb !important;
  color: #26588b !important;
  font-weight: 600;
  font-size: 12px;
  width: 135px;
  border-radius:  6px 0 0 6px !important;
}
.customExamfileBtn:hover {
  background-color: #26588b !important;
  color: #ffffff !important;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/uploadalltype.vue